import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const Intro = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 6% 10% 0%" }}>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#213555"}
            paddingBottom={"10%"}
          >
            By investing in climate resilience, AI, secondary city development,
            and social entrepreneurship, AIR envisions a future where African
            communities have the tools and resources to address their own
            challenges, build resilience, and foster economic opportunity
            independently.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} paddingLeft={{ xs: "0%", sm: "4%" }}>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            paddingBottom={{ xs: "2%", sm: "2%" }}
            lineHeight={1.5}
          >
            The African Innovation and Resilience Fund (AIR Fund) is a five-year
            impact investing philanthropic initiative addressing critical
            investment gaps in Sub-Saharan Africa's secondary cities. With a
            focus on climate resilience, artificial intelligence (AI), secondary
            city development, and community-led innovation, AIR Fund aims to
            empower these underserved urban centers to become engines of
            sustainable economic growth and resilience.
          </Typography>

          <Typography
            variant={"body1"}
            fontWeight={500}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "2% 0%", sm: "2% 0%" }}
            lineHeight={1.5}
          >
            Africa’s secondary cities, home to nearly 40% of the region’s 472
            million urban residents, are vital hubs of economic growth and
            population migration. However, they receive less than 5% of global
            funding for climate adaptation, innovation, and development, leaving
            millions vulnerable to escalating risks such as climate disasters,
            food insecurity, and economic instability. By investing
            strategically, AIR Fund seeks to bridge this gap, targeting
            interventions that save lives, protect livelihoods, and catalyze
            inclusive development.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Intro;
